<template>

<div class='col-12'>

    <loading-div v-if='!isReady'></loading-div>
        
    <div class='alert alert-info mt-4 mb-4' v-if='isReady && !offers.length'>
        Няма подадени оферти за тази процедура.
    </div>

    <div v-if='isReady && offers.length'>
        
        <div :class='["tenders", { winner : $parent.tp.offer_id == o.id }]' 
              v-for='o in offers'>
            
            <button @click='selectWinner(o)' 
                    v-if='!$parent.tp.offer_id'
                    class='btn btn-primary btn-lg float-right'>
                <span class="icon icon-medal"></span>
                Избери тази оферта
            </button>

            <div v-if='$parent.tp.offer_id == o.id' class="logo-check">
                <img src="/resources/images/check.svg" alt="Logo Videa" >
                <strong>Победител</strong>
            </div>

            <div class="tender-owner d-flex align-items-center mb-3">
                <div class="owner-profile-pic">
                    <img v-if="o.user.avatar" :src='o.user.avatar'> 
                    <img v-else src='/resources/images/static/user-pic.jpg'> 
                </div>
                <div>
                    <h4 class="mb-1">
                        <a :href='"/contractors/" + o.user.id' target="_blank">
                            {{ o.user.name }}
                        </a>
                    </h4>
                    Рейтинг (като изпълнител) : 
                    <user-rating v-if="o.user.worker_rating" :rating='o.user.worker_rating'></user-rating> 
                </div>
            </div>

            <div class="tender-offer mb-3 pb-md-5">
            
                <h4 class="mb-1">
                    Данни за офертата: 
                </h4>

                <div>
                    Цена: <strong class="txt-orange">{{ o.cost }} BGN</strong>
                </div>
                <div>
                    Срок: <strong class="txt-orange">{{ o.days }} дни</strong>
                </div>
                <div class="mt-4"> 
                    Описание:<br>
                    <strong>{{ o.desc }}</strong>
                </div>
            </div>

            <div class='alert alert-info' v-if='!o.files.length'>
                <span class="icon icon-info3"></span>
                Няма прикачени файлове към тази оферта
            </div>

            <div v-if='o.files.length' class="tender-files row">

                <div class="col-12">

                    <ul class="list-inline d-flex justify-content-center justify-content-lg-end align-items-center files-view admin-files-view">
                        <li @click="grid = false" :class="[ 'list-inline-item', { active : !grid }]">
                            <span class="icon icon-list"></span>
                        </li>

                        <li @click="grid = true" :class="[ 'list-inline-item', { active : grid }]">
                            <span class="icon icon-grid"></span>
                        </li>
                    </ul>
                </div>
            
                <div class="col-12">
                    <div :class="{ 'grid-view' : grid, 'list-view' : !grid  }">
                        <file-grid :files='o.files' 
                               :conf='getGridConfig(o)'
                               :params='{ o : o.id }'></file-grid>
                    </div>
                </div>

            </div>

        </div>

    </div>

</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        data() {
            return {

                isReady : false,
                offers  : [],
                grid    : true,

            }
        },

        methods : {

            selectWinner( o ) {
                if( !confirm('Сигурни ли сте че искате да изберете тази оферта за победител в търга?') ) {
                    return;
                }

                this.ajax.call('tp:swn', { o : o.id }, (r) => {
                    
                    if( r.status == 'success' ) {

                        this.$parent.tp.offer_id = o.id;

                        $.notify('Офертата беше избрана','success');

                    } else {

                        $.notify( r.message, r.status );

                    }

                })
            },

            getData() {

                this.ajax.call('tp:gof', { tp : this.$parent.tp.id }, (r) => {

                    if( r.status == 'success' ) {

                        this.arrangeOffers( r.data );

                        this.isReady = true;
                    
                    } else {

                        $.notify( r.message, r.status );
                    }

                })

            },

            arrangeOffers( offers ) {
                if( !this.$parent.tp.offer_id ) {
                    //No Winner
                    this.offers = offers;

                    return;
                }

                var winner = false;

                for( var i in offers ) {

                    if( offers[i].id == this.$parent.tp.offer_id ) {
                        //Winner
                        winner = offers[i];
                    } else {

                        this.offers.push( offers[i] );
                    }

                }

                if( winner ) {
                   this.offers.unshift( winner );
                }

            },

            getGridConfig(o) {

                return {
                    info        : "",
                    lightBoxId  : 'offer-' + o.id,
                    download    : true,
                    remove      : false
                }

            },

        }

    }
</script>
